import { NavLink, Outlet } from 'react-router-dom'
import { useAuth } from '../auth/useAuth'
import { PendingWorkIndicator } from './PendingWorkIndicator'

/**
 * App shell. The navigation collapses to a single row on small screens; the
 * plan view itself does the heavier responsive work for onsite use.
 */
export function Layout() {
  const { user, can, signOut } = useAuth()

  return (
    <div className="app-shell">
      <header className="app-header">
        <NavLink to="/" className="app-brand">
          CustomReg Event Prep
        </NavLink>

        <nav className="app-nav" aria-label="Main">
          <NavLink to="/events">Events</NavLink>
          <NavLink to="/my-work">My work</NavLink>
          {can('Coordinator') ? <NavLink to="/templates">Templates</NavLink> : null}
          {can('Admin') ? <NavLink to="/users">Users</NavLink> : null}
        </nav>

        <div className="app-user">
          {user ? (
            <>
              <span className="app-user-name">
                {user.displayName}
                <span className="app-user-role">{user.role}</span>
              </span>
              <NavLink to="/settings/notifications" className="app-settings-link">
                Reminders
              </NavLink>
              <button type="button" onClick={signOut}>
                Sign out
              </button>
            </>
          ) : null}
        </div>
      </header>

      <PendingWorkIndicator />

      <main className="app-main">
        <Outlet />
      </main>
    </div>
  )
}
